const NAMESPACE = "linkToSharedObjectModal";

const KEYS = {
    programGroupSelectorLabel: "programGroupSelectorLabel",
    noProgramGroupItemLabel: "noProgramGroupItemLabel",
    descriptionLabel: "descriptionLabel",
    makeSelectionLabel: "makeSelectionLabel"
};

const MESSAGES = {
    [KEYS.programGroupSelectorLabel]: {
        value: "Program group",
        comment: "Label for program group selector"
    },
    [KEYS.noProgramGroupItemLabel]: {
        value: "None (current program only)",
        comment: "Label for 'none' option in program group selector"
    },
    [KEYS.descriptionLabel]: {
        value: "Description:",
        comment: "Label for the header for the description section."
    },
    [KEYS.makeSelectionLabel]: {
        value: "Make a selection...",
        comment: "Label for the 'Make a selection...' item."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
